import produce from 'immer';
import './types';
import {
    SET_STATS_LEADERS,
    SET_NAV_ITEM,
    SET_SORT,
    SET_FILTER_ITEM,
    SET_RESET_FILTERS,
    SET_BENCHMARKING,
    SET_STATS_LEADERS_REQUEST,
    REMOVE_STATS_LEADERS_REQUEST,
    SET_DATA_TYPE
} from '../actions';
import { setStatsLeaders } from './set-stats-leaders';
import { setNavItem } from './set-nav-item';
import { setFilterItem } from './set-filter-item';
import { setSort } from './set-sort';
import { setBenchmarking } from './set-benchmarking';
import { setDataType } from './set-data-type';
import { setResetFilters } from './set-reset-filters';
import { setStatsLeadersRequest } from './set-stats-leaders-request';
import { removeStatsLeadersRequest } from './remove-stats-leaders-request';
import { DATA_TYPE } from '../../../../../../statspro/js/components/StatsLeaders/config/data-type';

/**
 * @type {StatsLeadersState}
 */
const initialState = {
    nav: {
        playerCount: 20,
        category: 'Key Stats',
        competition: {
            id: null
        },
        season: {
            id: null
        },
        round: {
            id: null,
            number: null
        }
    },
    sort: {
        columnId: null,
        sortDirection: 'descending'
    },
    filters: {
        positions: [],
        teams: []
    },
    benchmarking: {
        isActive: false
    },
    dataType: {
        type: DATA_TYPE.TOTALS
    },
    values: {
        stats: null,
        players: null,
        teams: null,
    },
    keys: {
        seasons: {},
        rounds: {}
    },
    requests: []
};

/**
 * @param {StatsLeadersState} state - The Redux state.
 * @param {SetStatsLeadersActions} action - The Redux action.
 * @return {StatsLeadersState} The updated Redux state.
 */
export const statsLeadersReducer = ( state = initialState, action ) => {
    return produce( state, draft => {
        switch ( action.type ) {
            case SET_STATS_LEADERS:
                setStatsLeaders( draft, action.payload );
                break;
            case SET_STATS_LEADERS_REQUEST:
                setStatsLeadersRequest( draft, action.payload );
                break;
            case REMOVE_STATS_LEADERS_REQUEST:
                removeStatsLeadersRequest( draft, action.payload );
                break;
            case SET_NAV_ITEM:
                setNavItem( draft, action.payload );
                break;
            case SET_FILTER_ITEM:
                setFilterItem( draft, action.payload );
                break;
            case SET_RESET_FILTERS:
                setResetFilters( draft );
                break;
            case SET_SORT:
                setSort( draft, action.payload );
                break;
            case SET_BENCHMARKING:
                setBenchmarking( draft, action.payload );
                break;
            case SET_DATA_TYPE:
                setDataType( draft, action.payload );
                break;
            default:
                draft;
        }
    } );
};